<div class="donut-chart" id="{{chartId}}" #containerDonutChart></div>
